export default "__VITE_ASSET__o0p1LAVw__"